export default "__VITE_ASSET__qD9utdDt__"